const allowedDeepLinkPrefixes = [
  "/einladung/",
  "/passwort-reset/",
  "/tische/",
  "/sessions/",
  "/games/",
  "/marketplace/",
  "/account/",
];

const allowedDeepLinkRoots = new Set(["/", "/abstimmungen", "/account"]);

export function safeDeepLinkPath(raw: string): string | null {
  try {
    const url = new URL(raw);
    if (url.username || url.password) return null;

    let pathname: string;
    if (url.protocol === "https:" && url.origin === "https://gambling.dc0der.com") {
      pathname = url.pathname;
    } else if (url.protocol === "fbucks:") {
      const routeHost = url.hostname;
      pathname = routeHost ? `/${routeHost}${url.pathname}` : url.pathname;
    } else {
      return null;
    }

    if (!pathname.startsWith("/") || pathname.includes("\\")) return null;
    const allowed =
      allowedDeepLinkRoots.has(pathname) ||
      allowedDeepLinkPrefixes.some((prefix) => pathname.startsWith(prefix));
    return allowed ? `${pathname}${url.search}${url.hash}` : "/";
  } catch {
    return null;
  }
}
